<template lang="pug">
#custom-render
  template(v-if="loadComplete")
    page-render(
        ref="vFormRef"
    )
  template(v-else)
    .empty 正在初始化页面
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
import { mapState } from "vuex";
import { componentList } from "@/CommonDP/exportComponentList";
export default {
  props: {
    // 表单id
    formId: {
      type: String,
      default: "",
    },
    prjId: {
      type: String,
      default: "",
    },

    formCode: {
      type: String,
      default: "",
    },
    options: Object,
  },
  data() {
    return {
      formJson: {},
      loadComplete: false, // 表单加载完毕
    };
  },
  provide() {
    return {
      previewMode: false,
      componentList,
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
    }),
  },
  watch: {
    options: {
      async handler(val) {
        if (val && Object.keys(val).length) {
          this.loadComplete = true;
          await this.$nextTick();
          this.$refs.vFormRef.formJsonObj = val;
        }
      },
      immediate: true,
    },

    // relateId: {
    //   handler (val) {
    //     console.log(val, 'relateId');
    //     if (val && this.$refs.table) {
    //       this.$refs.table.init(this.previewMode);
    //     } else if (val && !this.$refs.table) {
    //       this.$nextTick(() => this.$refs.table.init(this.previewMode))
    //     }
    //   },
    //   immediate: true
    // }
  },
  methods: {},
};
</script>

<style scoped>
@import "../../../lib/pageDesign/pageDesigner.css";

#custom-render {
  height: 100%;
}
</style>
